export class TextMediaButtonController {
  private textmedia = document.querySelectorAll('.js-textmedia');

  constructor() {
    if (this.textmedia) {
      for (let i = 0; i < this.textmedia.length; i++) {
        if (this.textmedia[i].querySelector('p:last-of-type .button')) {
          this.textmedia[i].classList.add('textmedia--hasAbsButton');
        }
      }
    }
  }
}

